/* eslint-disable */
const interestAreas = [
  {
    id: 'SIS-POL-GOB-PL-SE',
    label: 'Sobre Sistema Político, Gobierno, Poder Legislativo y Sistema Electoral',
    children: [
      {
        id: 'BG-P-TP',
        label: 'Buen gobierno, probidad y transparencia pública'
      },
      {
        id: 'EP-LDP',
        label: 'Estado Plurinacional y libre determinación de los pueblos'
      },
      {
        id: 'I-OE-RP',
        label: 'Instituciones, organización del Estado y régimen político'
      },
      {
        id: 'RE-IR-CT',
        label: 'Relaciones Exteriores, integración regional y cooperación transfronteriza'
      },
      {
        id: 'SP-DN-RFA',
        label: 'Seguridad pública, defensa nacional y rol de las Fuerzas Armadas'
      },
      {
        id: 'SE-OP',
        label: 'Sistema electoral y organizaciones políticas'
      }
    ]
  },
  {
    id: 'PC-D-N-C',
    label: 'Sobre Principios Constitucionales, Democracia, Nacionalidad y Ciudadanía',
    children: [
      {
        id: 'IFDIDH',
        label: 'Integración de fuentes del derecho internacional de los Derechos Humanos'
      },
      {
        id: 'MPP-PI-PTD',
        label: 'Mecanismos de participación popular, de los pueblos indígenas y el pueblo tribal afrodescendiente'
      },
      {
        id: 'NC',
        label: 'Nacionalidad y ciudadanía'
      },
      {
        id: 'PA',
        label: 'Preámbulo'
      },
      {
        id: 'PRNCP',
        label: 'Principios'
      }
    ]
  },
  {
    id: 'FE-OADE-JT-GL-OF',
    label: 'Forma de Estado, Ordenamiento, Autonomía, Descentralización, Equidad,\
      Justicia Territorial, Gobiernos Locales y Organización Fiscal',
    children: [
      {
        id: 'ATI',
        label: 'Autonomías territoriales e indígenas'
      },
      {
        id: 'EODE',
        label: 'Estructura organizacional y descentralizada del Estado'
      },
      {
        id: 'GLOC',
        label: 'Gobiernos locales'
      },
      {
        id: 'I-CT',
        label: 'Igualdad y cargas tributarias'
      },
      {
        id: 'MET',
        label: 'Mecanismos de equidad territorial'
      },
      {
        id: 'ME',
        label: 'Modernización del Estado'
      },
      {
        id: 'OTIE-DPA',
        label: 'Organización territorial interior del Estado y división político-administrativa'
      },
      {
        id: 'RA',
        label: 'Reforma administrativa'
      },
      {
        id: 'R-RCC',
        label: 'Ruralidad y relación campo-ciudad'
      },
      {
        id: 'TI-ZE',
        label: 'Territorios insulares y zonas extremas'
      },
    ]
  },
  {
    id: 'DER-FUN',
    label: 'Derechos Fundamentales',
    children: [
      {
        id: 'AF-EP',
        label: 'Admisión a las funciones y empleos públicos'
      },
      {
        id: 'C-DD',
        label: 'Comunicación y derechos digitales'
      },
      {
        id: 'DPDA',
        label: 'Debido proceso con todos sus derechos asociados'
      },
      {
        id: 'DH',
        label: 'Derecho a la honra'
      },
      {
        id: 'DNC-HLS',
        label: 'Derecho a la negociación colectiva, huelga y libertad sindical'
      },
      {
        id: 'DSI',
        label: 'Derecho a la seguridad individual'
      },
      {
        id: 'DV-J-RIVF-SC',
        label: 'Derecho a la verdad, la justicia, la reparación integral de las\
          víctimas, sus familiares y a la sociedad en su conjunto'
      },
      {
        id: 'DV-IFP',
        label: 'Derecho a la vida y a la integridad física y psíquica'
      },
      {
        id: 'DV-C-T-T',
        label: 'Derecho a la vivienda, a la ciudad, a la tierra y al territorio'
      },
      {
        id: 'DC-RTD-CNR',
        label: 'Derecho al cuidado y reconocimiento del trabajo doméstico\
          y de cuidado no remunerado'
      },
      {
        id: 'DD-AF-R',
        label: 'Derecho al deporte, la actividad física y la recreación'
      },
      {
        id: 'DSA',
        label: 'Derecho al sustento alimenticio'
      },
      {
        id: 'DT-P',
        label: 'Derecho al trabajo y su protección'
      },
      {
        id: 'DR',
        label: 'Derecho a reunión'
      },
      {
        id: 'DVAS-EE',
        label: 'Derecho a vivir en un ambiente sano y ecológicamente equilibrado'
      },
      {
        id: 'DP',
        label: 'Derecho de petición'
      },
      {
        id: 'DPROP',
        label: 'Derecho de propiedad'
      },
      {
        id: 'DHA-S-ODHA',
        label: 'Derecho humano al agua y saneamiento y otros derechos humanos ambientales'
      },
      {
        id: 'DCIV',
        label: 'Derechos civiles'
      },
      {
        id: 'DM',
        label: 'Derechos de las mujeres'
      },
      {
        id: 'DPCRE',
        label: 'Derechos de las personas chilenas residentes en el extranjero'
      },
      {
        id: 'DPCD',
        label: 'Derechos de las personas con discapacidad'
      },
      {
        id: 'DPAE',
        label: 'Derechos de las personas frente a la Administración del Estado'
      },
      {
        id: 'DPM',
        label: 'Derechos de las personas mayores'
      },
      {
        id: 'DI-CI-T',
        label: 'Derechos individuales y colectivos indígenas y tribales'
      },
      {
        id: 'DPOL',
        label: 'Derechos políticos'
      },
      {
        id: 'DS-R',
        label: 'Derechos sexuales y reproductivos'
      },
      {
        id: 'EDUC',
        label: 'Educación'
      },
      {
        id: 'IGLEY',
        label: 'Igualdad ante la ley'
      },
      {
        id: 'IH-C',
        label: 'Inviolabilidad del hogar y de las comunicaciones'
      },
      {
        id: 'LASOC',
        label: 'Libertad de asociación'
      },
      {
        id: 'LC-R',
        label: 'Libertad de conciencia y religión'
      },
      {
        id: 'LEO-i-CP',
        label: 'Libertad de emitir opinión, de información, de culto y de prensa'
      },
      {
        id: 'LE-DAE',
        label: 'Libertad de emprender y desarrollar actividades económicas'
      },
      {
        id: 'LEXP',
        label: 'Libertad de expresión'
      },
      {
        id: 'LPER',
        label: 'Libertad personal'
      },
      {
        id: 'MIG',
        label: 'Migrantes'
      },
      {
        id: 'NJ',
        label: 'Niñez y juventud'
      },
      {
        id: 'R-PL',
        label: 'Reinserción y privados de libertad'
      },
      {
        id: 'SPDS',
        label: 'Salud en todas las políticas con enfoque en los determinantes sociales'
      },
      {
        id: 'SS-SP',
        label: 'Seguridad Social y sistema de pensiones'
      }
    ]
  },
  {
    id: 'MA-DN-BNC-ME',
    label: 'Medio Ambiente, Derechos de la Naturaleza, Bienes Naturales Comunes\
      y Modelo Económico',
    children: [
      {
        id: 'C-CLIM',
        label: 'Crisis climática'
      },
      {
        id: 'DP-JI-DA-PNRA',
        label: 'Deber de protección, justicia intergeneracional, delitos\
          ambientales y principio de no regresión ambiental'
      },
      {
        id: 'DA-DAP-I-JA',
        label: 'Democracia ambiental, derechos de acceso a la participación,\
          información y justicia ambiental'
      },
      {
        id: 'DHA-ECA',
        label: 'Derecho humano al agua y estatuto constitucional del agua'
      },
      {
        id: 'DN-VNH',
        label: 'Derechos de la naturaleza y vida no humana'
      },
      {
        id: 'DS-BV',
        label: 'Desarrollo Sostenible, buen vivir'
      },
      {
        id: 'EST-ANT',
        label: 'Estatuto Antártico'
      },
      {
        id: 'ECE',
        label: 'Estatuto constitucional de la energía'
      },
      {
        id: 'ECT-T',
        label: 'Estatuto constitucional de la tierra y el territorio'
      },
      {
        id: 'ECTM',
        label: 'Estatuto constitucional del territorio marítimo'
      },
      {
        id: 'ECM',
        label: 'Estatuto constitucional sobre minerales'
      },
      {
        id: 'M-B-PB-BNC',
        label: 'Medioambiente, biodiversidad, principios de la Bioética y\
          bienes naturales comunes'
      },
      {
        id: 'MOD-EC',
        label: 'Modelo económico'
      },
      {
        id: 'RPE-PF',
        label: 'Régimen público económico y política fiscal'
      },
      {
        id: 'SOB-AL',
        label: 'Soberanía alimentaria'
      }
    ]
  },
  {
    id: 'SJ-OAC-RF',
    label: 'Sistema de Justicia, Órganos Autónomos de Control y Reforma Constitucional',
    children: [
      {
        id: 'AC-GIDH',
        label: 'Acciones constitucionales y garantías institucionales a los Derechos Humanos'
      },
      {
        id: 'DP-JA',
        label: 'Defensoría de los Pueblos y Justicia administrativa'
      },
      {
        id: 'JL',
        label: 'Justicia local'
      },
      {
        id: 'MP-SPP',
        label: 'Ministerio Público y sistema de persecución penal'
      },
      {
        id: 'OC-OA',
        label: 'Órganos de control y órganos autónomos'
      },
      {
        id: 'PJ-SPI',
        label: 'Pluralismo jurídico y sistemas propios indígenas'
      },
      {
        id: 'RC',
        label: 'Reforma constitucional'
      },
      {
        id: 'SJC',
        label: 'Sistema de justicia constitucional'
      }
    ]
  },
  {
    id: 'SC-C-C-T-A-P',
    label: 'Sistemas de Conocimientos, Culturas, Ciencia, Tecnología, Artes y Patrimonios',
    children: [
      {
        id: 'DCC-T',
        label: 'Derecho a la Ciencia, Conocimiento y Tecnología'
      },
      {
        id: 'DLI',
        label: 'Derecho a la libertad de investigación'
      },
      {
        id: 'DP-UICT',
        label: 'Derecho a la protección contra los usos indebidos de la ciencia y tecnología'
      },
      {
        id: 'DD-AF-CD',
        label: 'Derecho al deporte, la actividad física y la cultura del deporte'
      },
      {
        id: 'DRPI-I-SA',
        label: 'Derecho al resguardo de la propiedad intelectual, industrial y saberes ancestrales'
      },
      {
        id: 'DP-BCT',
        label: 'Derecho a participar de los beneficios de la ciencia y la tecnología'
      },
      {
        id: 'I-GF-PPC-AHCT',
        label: 'Institucionalidad, gasto fiscal y políticas públicas en Cultura,\
          Artes, Humanidades, Ciencia y Tecnología'
      },
      {
        id: 'PIC-A-I-D',
        label: 'Presupuesto e Inversión en Cultura, Artes, Investigación y Desarrollo'
      },
      {
        id: 'REC-A-H-C-T',
        label: 'Rol del Estado en Cultura, Artes, Humanidades, Ciencia y Tecnología'
      }
    ]
  }
];

export default interestAreas;
